import React from "react";

export const OpenTeamIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" fill="none" viewBox="0 0 10 6">
      <path stroke="#113357" strokeLinecap="round" strokeWidth="1.2" d="m1 1 3.93 3.93a.1.1 0 0 0 .14 0L9 1"></path>
    </svg>
  );
};
